import {coreApi} from './core'

export const fileService = {
    generateId: async () => await coreApi.post('file', {}),
    upload: async (id, file) => {
        const form = new FormData
        form.append('formFile', file)
        form.append('fileName', file.name)
        return await coreApi.post(`file/upload/${id}`, form)
    },
    download: async (id) => await coreApi.post(`file/download/${id}`),
}
